import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PageHeader from "../../components/ui/PageHeader";
import FilterBar from "../../components/ui/FilterBar";

import { useToast } from "../../contexts/ToastContext";
import { useAuth } from "../../contexts/AuthContext";

import {
  ChevronLeft,
  ChevronRight,
  Plus,
  Calendar as CalendarIcon
} from "lucide-react";

import calendarService from "../../services/calendarService";
import CalendarPreview from "../../components/common/CalendarPreview";
import CalendarYearView from "../../components/calendar/CalendarYearView";

import "../../styles/dashboard.css";

const RHCalendarPage = () => {
  const navigate = useNavigate();
  const toast = useToast();

  // =========================================================
  // UTILISATEUR CONNECTè‰
  // =========================================================
  const { user } = useAuth();

  console.log("========================================");
  console.log("[RHCalendarPage] UTILISATEUR CONNECTè‰");
  console.log("[RHCalendarPage] user =", user);
  console.log("[RHCalendarPage] user.role =", user?.role);
  console.log("========================================");

  // =========================================================
  // STATES
  // =========================================================
  const [viewMode, setViewMode] = useState("year");

  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear()
  );

  const [calendarEvents, setCalendarEvents] = useState([]);

  const [loading, setLoading] = useState(false);

  const [filterType, setFilterType] = useState("all");

  const [searchQuery, setSearchQuery] = useState("");

  // =========================================================
  // CHARGER LES è‰Vè‰NEMENTS
  // =========================================================
  const loadEvents = async () => {
    console.log(
      "[RHCalendarPage] Chargement des événements..."
    );

    setLoading(true);

    try {
      const startDate = `${currentYear}-01-01`;
      const endDate = `${currentYear}-12-31`;

      console.log(
        "[RHCalendarPage] startDate =",
        startDate
      );

      console.log(
        "[RHCalendarPage] endDate =",
        endDate
      );

      const events = await calendarService.getEvents({
        startDate,
        endDate
      });

      console.log(
        "[RHCalendarPage] événements reè§us =",
        events
      );

      console.log(
        "[RHCalendarPage] nombre événements =",
        events?.length || 0
      );

      setCalendarEvents(events || []);
    } catch (err) {
      console.error(
        "[RHCalendarPage] Erreur chargement événements :",
        err
      );

      toast.error(
        "Impossible de charger les événements du calendrier."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // CHARGER è€ CHAQUE CHANGEMENT D'ANNè‰E
  // =========================================================
  useEffect(() => {
    loadEvents();
  }, [currentYear]);

  // =========================================================
  // Vè‰RIFICATION DE L'UTILISATEUR
  // =========================================================
  useEffect(() => {
    console.log(
      "========================================"
    );

    console.log(
      "[RHCalendarPage] useEffect USER"
    );

    console.log(
      "[RHCalendarPage] user =",
      user
    );

    console.log(
      "[RHCalendarPage] user?.role =",
      user?.role
    );

    console.log(
      "========================================"
    );
  }, [user]);

  // =========================================================
  // FILTRAGE
  // =========================================================
  const filteredEvents = calendarEvents.filter((e) => {
    // -------------------------------------------------------
    // FILTRE PAR TYPE
    // -------------------------------------------------------
    if (
      filterType !== "all" &&
      e.event_type !== filterType.toUpperCase()
    ) {
      return false;
    }

    // -------------------------------------------------------
    // FILTRE PAR RECHERCHE
    // -------------------------------------------------------
    if (searchQuery) {
      const q = searchQuery.toLowerCase();

      const title =
        e.title?.toLowerCase() || "";

      const employee =
        e.details?.employee?.toLowerCase() || "";

      if (
        !title.includes(q) &&
        !employee.includes(q)
      ) {
        return false;
      }
    }

    return true;
  });

  // =========================================================
  // DEBUG EVENTS
  // =========================================================
  console.log(
    "[RHCalendarPage] filteredEvents =",
    filteredEvents
  );

  // =========================================================
  // RENDER
  // =========================================================
  return (
    <div style={{ padding: "24px" }}>

      {/* =====================================================
          HEADER
      ====================================================== */}
      <PageHeader
        title="Calendrier RH Annuel"
        subtitle="Gérez et consultez tous les congés, jours fériés, entretiens et événements d'entreprise."
        actions={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}
          >

            {/* =================================================
                MODE MOIS / ANNè‰E
            ================================================== */}
            <div
              style={{
                display: "flex",
                background: "var(--bg-subtle)",
                padding: "3px",
                borderRadius: "var(--radius-md)",
                border: "1px solid var(--border)"
              }}
            >

              <button
                onClick={() => setViewMode("month")}
                style={{
                  padding: "6px 14px",
                  borderRadius: "var(--radius-sm)",
                  border: "none",
                  fontSize: "0.85rem",
                  fontWeight: "600",

                  backgroundColor:
                    viewMode === "month"
                      ? "var(--bg-card)"
                      : "transparent",

                  color:
                    viewMode === "month"
                      ? "var(--primary)"
                      : "var(--text-muted)",

                  boxShadow:
                    viewMode === "month"
                      ? "var(--shadow-xs)"
                      : "none",

                  cursor: "pointer"
                }}
              >
                Mois
              </button>

              <button
                onClick={() => setViewMode("year")}
                style={{
                  padding: "6px 14px",
                  borderRadius: "var(--radius-sm)",
                  border: "none",
                  fontSize: "0.85rem",
                  fontWeight: "600",

                  backgroundColor:
                    viewMode === "year"
                      ? "var(--bg-card)"
                      : "transparent",

                  color:
                    viewMode === "year"
                      ? "var(--primary)"
                      : "var(--text-muted)",

                  boxShadow:
                    viewMode === "year"
                      ? "var(--shadow-xs)"
                      : "none",

                  cursor: "pointer"
                }}
              >
                Année
              </button>

            </div>

            {/* =================================================
                AJOUTER JOUR Fè‰RIè‰
            ================================================== */}
            <button
              onClick={() =>
                navigate("/rh/calendar/events/new")
              }
              className="btn btn-primary"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}
            >
              <Plus size={18} />

              <span>
                Ajouter un jour férié
              </span>
            </button>

          </div>
        }
      />

      {/* =====================================================
          NAVIGATION + FILTRES
      ====================================================== */}
      <div
        className="ui-card"
        style={{
          padding: "16px",
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "16px"
        }}
      >

        {/* ===================================================
            NAVIGATION ANNè‰E
        ==================================================== */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px"
          }}
        >

          <button
            onClick={() =>
              setCurrentYear((y) => y - 1)
            }
            className="btn btn-icon"
            style={{
              padding: "8px",
              border: "1px solid var(--border)"
            }}
          >
            <ChevronLeft size={20} />
          </button>

          <h2
            style={{
              fontSize: "1.4rem",
              fontWeight: "800",
              color: "var(--text-main)",
              margin: 0,
              minWidth: "90px",
              textAlign: "center"
            }}
          >
            {currentYear}
          </h2>

          <button
            onClick={() =>
              setCurrentYear((y) => y + 1)
            }
            className="btn btn-icon"
            style={{
              padding: "8px",
              border: "1px solid var(--border)"
            }}
          >
            <ChevronRight size={20} />
          </button>

          <button
            onClick={() =>
              setCurrentYear(
                new Date().getFullYear()
              )
            }
            className="btn btn-outline btn-small"
            style={{
              fontSize: "0.8rem"
            }}
          >
            Aujourd'hui
          </button>

        </div>

        {/* ===================================================
            FILTRES
        ==================================================== */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap"
          }}
        >

          <select
            value={filterType}
            onChange={(e) =>
              setFilterType(e.target.value)
            }
            style={{
              padding: "8px 12px",
              borderRadius: "var(--radius-md)",
              border: "1px solid var(--border)",
              fontSize: "0.88rem",
              backgroundColor: "var(--bg-main)"
            }}
          >
            <option value="all">
              Tous les types
            </option>

            <option value="leave">
              Congés
            </option>

            <option value="holiday">
              Jours fériés
            </option>

            <option value="interview">
              Entretiens
            </option>

            <option value="hr_event">
              Evénements RH
            </option>
          </select>

          <input
            type="text"
            placeholder="Rechercher..."
            value={searchQuery}
            onChange={(e) =>
              setSearchQuery(e.target.value)
            }
            style={{
              padding: "8px 12px",
              borderRadius: "var(--radius-md)",
              border: "1px solid var(--border)",
              fontSize: "0.88rem",
              backgroundColor: "var(--bg-main)",
              width: "180px"
            }}
          />

        </div>
      </div>

      {/* =====================================================
          CONTENU CALENDRIER
      ====================================================== */}
      {loading ? (

        <div
          className="ui-card"
          style={{
            padding: "60px",
            textAlign: "center",
            color: "var(--text-muted)"
          }}
        >
          Chargement du calendrier RH...
        </div>

      ) : viewMode === "year" ? (

        <CalendarYearView
          year={currentYear}
          events={filteredEvents}

          /*
           * IMPORTANT :
           * On transmet maintenant l'utilisateur connecté
           * à CalendarYearView.
           */
          user={user}

          onEdit={(event) => {
            console.log(
              "[RHCalendarPage] onEdit event =",
              event
            );

            navigate(
              `/rh/calendar/events/${event.id}/edit`,
              {
                state: {
                  from: "/rh/calendar"
                }
              }
            );
          }}
        />

      ) : (

        <div
          className="ui-card"
          style={{
            padding: "20px"
          }}
        >
          <CalendarPreview />
        </div>

      )}

    </div>
  );
};

export default RHCalendarPage;
